<template>
  <div class="header">
    <div class="header-verification container">
      <img :src="logo" class="provider_logo" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "headerview",
  data() {
    return {
      providerId: null,
      logo: null,
      noorplayLogo: require("@/assets/NoorPlayLogo.png"),
      net5Logo: require("@/assets/Net5-Logo.png"),
      nammaflixLogo: require("@/assets/nammaflix_logo.png")
    }
  },
  created() {
    if (this.$router.currentRoute.query) {
      this.providerId = this.$router.currentRoute.query.providerid;
      this.logo = this.providerId === 'net54321' ? this.net5Logo : (this.providerId === 'noorplay') ? this.noorplayLogo : (this.providerId === 'z01x1wPo') ? this.nammaflixLogo : '';
    }
  }
};
</script>

<style lang="scss">
.header {
  background: #1d1d1d;
  position: fixed;
  top: 0;
  z-index: 888;
  width: 100%;
  .container {
    max-width: 1100px;
    margin: 0 auto;
    padding: 0.6rem;
  } 
  .provider_logo{
    height: 28px;
    width: 75px;
    cursor: pointer;
  }
}
</style>
